// extracted by mini-css-extract-plugin
export default {"card":"PoolTable_card__TRJ8l"};